import React from 'react'
import PropTypes from 'prop-types'
import { message, Button, Typography, Input, Icon, Form, Row, Col, Tooltip } from 'antd';
import { Queries, Mutations } from '../../../graphql'
import Container from '../../../components/user/Container'
import { withApollo } from 'react-apollo'
import { ErrorMessageFormAPI } from '../../../utils/checkError'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import Step4 from '../ForgetPassword/detail/step4'
import { appVersion, versionWeb, checkLinkURL } from '../../../utils/auth'
import axiosAPI, { urlAttachFile } from "../../../config/axiosAPI";

const { Text, Title } = Typography

class ChangePassword extends React.Component {
    state = {
        otpToSead: {},
        dataProfileSSO: {},
    };

    switchShowPage = async (page, otpData = {})=>{
		await this.setState({
			confirmpassword: page,
			otpToSead: otpData
		})
	}

    getInfoAuth = async () =>{
		axiosAPI.get(`${checkLinkURL()}config/get-info-auth`)
		.then(response => {
			console.log("response SSO : info-auth :", response.data.data)
            response.data.data.ssoId = response.data.data.username
			this.setState({
				dataProfileSSO: response.data.data,
                phoneNumber: response.data.data.phoneNumber[0]
			})
		}).catch(
			error => console.error(`Error: ${error}`)
		)
		// console.log("DataFetchAPI", DataFetchAPI)
	}

    onSwitchMainPage = async() =>{
      // this.props.history.replace(`/news`)
      window.location.href = '/news'
    }

    async componentDidMount(){
      this.getInfoAuth()
		// await this.fetchProfile()
    }


    render() {
        const { match, form, client } = this.props
        const { getFieldDecorator } = form
        const testInfo = '<p class="mb-2">รหัสผ่านประกอบไปด้วย</p><ul class="pl-3"><li>อักษรภาษาอังกฤษตัวพิมพ์ใหญ่ (A-Z)</li><li>อักษรภาษาอังกฤษตัวพิมพ์เล็ก (a-z)</li><li>ตัวเลขอย่างน้อย 1 ตัว (0-9)</li><li>สัญลักษณ์พิเศษอย่างน้อย 1 ตัว (!@#S%^&*(_+<>?;) </li><li>ความยาวขั้นต่ำ 8 ตัวอักษร</li><li>ห้ามมีจุด (. ) ในรหัสผ่าน</li><li>ห้ามมีชื่อ หรือ นามสกุลภาษาอังกฤษในรหัสผ่าน</li></ul>'
        console.log("client", this.props.client)
        return (
            <Container match={match} className="page-change-password">
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <Row type="flex" justify="center" align="top">
                    <Col span={24}>
                        <div className="card-container" id="page-profile" >
                            <div className="p-4 card-bg-green" style={{ borderRadius: "20px" }}>
                                    <div className="p-5" style={{ borderRadius: "20px", backgroundColor: "white" }}>
                                        <Step4
                                            autoFocus
                                            switchShowPage={this.switchShowPage}
                                            otpToSead={this.state.otpToSead}
                                            dataProfileSSO={this.state.dataProfileSSO}
                                            onSwitchMainPage={this.onSwitchMainPage}
                                            authLogin={true}
                                            pageChangePassword='auth'
                                            propsClient={client}
                                        />
                                    </div>
                                    {/* <div className="p-5" style={{ borderRadius: "20px", backgroundColor: "white" }}>
                                        <h3 className="">รหัสผ่านใหม่</h3>
                                        <Form onSubmit={this.handleSubmit}>
                                            <Form.Item 
                                                label={<b>รหัสผ่านเดิม</b>} 
                                                name="oldPassword" 
                                                className="mb-3"
                                            >
                                                {getFieldDecorator('oldPassword', {
                                                    rules: [{ required: true, message: 'กรุณากรอกรหัสผ่านเดิม' }]
                                                })(
                                                    <Input.Password type="password" maxLength="20" onBlur={this.changeoldPassword} />
                                                )}
                                            </Form.Item>
                                            <Form.Item 
                                                label={<b>ตั้งรหัสผ่านใหม่</b>} 
                                                name="newPassword" 
                                                className="mb-3"
                                            >
                                                <Tooltip placement="bottom" title={ <div dangerouslySetInnerHTML={{ __html: testInfo }} />}>
                                                    <Icon type="info-circle" style={{ position:"absolute",right:"0",top:"-30px" }}/>
                                                </Tooltip>
                                                {getFieldDecorator('newPassword', {
                                                    rules: [{ required: true, message: 'กรุณาตั้งรหัสผ่านใหม่' }]
                                                })(
                                                    <Input.Password type="password" maxLength="20" onBlur={this.changenewPassword} />
                                                )}
                                                
                                            </Form.Item>
                                            <Form.Item 
                                                label={<b>ยืนยันรหัสผ่าน</b>} 
                                                name="confirmNewPassword" 
                                                className="mb-3"
                                                rules={[{ required: true, message: 'ยืนยันรหัสผ่าน' }]}
                                            >
                                                {
                                                getFieldDecorator('confirmNewPassword', {
                                                    rules: [
                                                        { required: true, message: 'กรุณากรอกยืนยันรหัสผ่าน' },
                                                        {
                                                            validator: this.compareToFirstPassword,
                                                        }
                                                    ]
                                                })(
                                                    <Input.Password type="password" maxLength="20" onBlur={this.changeconfirmPassword}  />
                                                )}
                                            </Form.Item>

                                            <Form.Item style={{marginBottom: '15' }}>
                                                <Button type="primary btn-color-default btn-custom color-white" htmlType="submit">
                                                    ยืนยัน
                                                </Button>
                                            </Form.Item>

                                        </Form>
                                    </div> */}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    }
}

ChangePassword.defaultProps = {
	autoFocus: false
}

ChangePassword.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool,
   history: PropTypes.object,
}

const WrappedChangePassword = Form.create()(ChangePassword)
export default withApollo(WrappedChangePassword)